import { JsonObject } from '../../helpers';
import { ConnectorFeatureSet } from './';
import { ConnectorModel } from './connector.model';
import AzureFoundryIcon from '@/assets/connector-icons/azure-foundry.svg';
import { object, string } from 'yup';

export type AzureFoundryConfig = {
  resourceName: string;
  projectName: string;
  apiKey: string;
  apiKeyLast4?: string;
};

export class AzureFoundryConnectorModel extends ConnectorModel {
  config: AzureFoundryConfig;

  schema = object({
    name: string().required('Name is required'),
    type: string().required('Please choose a type'),
    config: object({
      resourceName: string().required('Resource name is required'),
      projectName: string().required('Project name is invalid'),
    }),
  });

  constructor(props: JsonObject = {}) {
    super(props);
    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'azure-foundry';
    this.typeLabel = 'Microsoft Foundry';
    this.iconSVG = AzureFoundryIcon;
    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: true,
      contextData: false,
      ingress: false,
    };
    this.config = (data.config as AzureFoundryConfig) || {
      resourceName: '',
      projectName: '',
      apiKey: '',
    };
    this.configSecrets = ['apiKey'];
    this.canListProviderModels = true;
  }

  get projectEndpoint(): string {
    const { resourceName, projectName } = this.config;
    if (!resourceName || !projectName) {
      return '';
    }

    return `https://${resourceName}.services.ai.azure.com/api/projects/${projectName}`;
  }

  static parseProjectEndpointUrl(
    url: string
  ): { resourceName: string; projectName: string } | null {
    const trimmed = url.trim();
    if (!trimmed) {
      return null;
    }

    try {
      const endpointUrl = new URL(trimmed);
      const hostMatch = endpointUrl.hostname.match(/^([a-z0-9-]+)\.services\.ai\.azure\.com$/);
      const pathMatch = endpointUrl.pathname.match(/^\/api\/projects\/([^/]+)\/?$/);

      if (
        endpointUrl.protocol !== 'https:' ||
        endpointUrl.port ||
        endpointUrl.username ||
        endpointUrl.password ||
        endpointUrl.search ||
        endpointUrl.hash ||
        !hostMatch ||
        !pathMatch
      ) {
        return null;
      }

      return { resourceName: hostMatch[1], projectName: pathMatch[1] };
    } catch {
      return null;
    }
  }
}
